export enum WageAllowanceCalculationTypeEnum {
  AmountWageAllowance = 1,
  PercentageWageAllowance = 2,
}
